import React, { useState } from 'react';
import { commonSearchFilterObj } from '../helpers/commonOptions';
import SearchButton from './SearchButton';
import { cn } from '../helpers/utils';

interface GenericSearchBarProps {
  initialValue?: string;
  title: string;
  placeholder: string;
  extraTitle?: string;
  searchClicked: (query: string) => void;
  className?: string;
  textInverted?: boolean;
}

const GenericSearchBar: React.FC<GenericSearchBarProps> = ({
  initialValue = '',
  className,
  textInverted,
  searchClicked,
  title,
  placeholder,
  extraTitle,
}) => {
  const [inputSearchValue, setInputSearchValue] = useState(initialValue);
  
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputSearchValue(event.target.value);
  };
  
  const handleSearchClick = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    commonSearchFilterObj.search = inputSearchValue;
    searchClicked(inputSearchValue);
  };

  return (
    <div data-testid="search-bar-component" className={cn('generic-search-bar__wrapper', className )}>
      <form onSubmit={handleSearchClick}>
        <div className="generic-search-bar">
          <div className="flex justify-between items-center h-full ">
            <div className="w-[calc(100%-200px)]">
              <label className="generic-search-bar__label" htmlFor="search-bar-input">
                <span className="sr-only">Zoeken&nbsp;</span>{title}
              </label>
              <input
                id="search-bar-input"
                data-testid="search-bar-input"
                className="generic-search-bar__input"
                placeholder={placeholder}
                type="text"
                value={inputSearchValue}
                onChange={handleSearchChange}
              />
            </div>
            <div className="w-[200px]">
              <SearchButton type='LARGE'/>
            </div>
          </div>
        </div>
        <div 
          className={cn(
            'lg:hidden mb-2 font-bold font-avantgarde text-[14px]',
            textInverted 
              ? 'text-white md:text-blue-900 max-md:drop-shadow-md' 
              : 'text-blue-900'
          )}
        >
          {extraTitle ? extraTitle : title}
        </div>
        <div className="generic-search-bar--small">
          <div className="flex justify-between h-full">
            <div className="w-[calc(100%-50px)]">
              <input
                aria-label="Zoeken in de buurt van"
                className="w-full h-full border border-none placeholder-stone-200 rounded-[2px] focus:outline-none"
                placeholder={placeholder}
                type="text"
                value={inputSearchValue}
                onChange={handleSearchChange}
              />
            </div>
            <div className="w-[50px]">
              <SearchButton type='SMALL'/>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};


export default GenericSearchBar;
